import '@hotwired/turbo-rails'
import { Application } from '@hotwired/stimulus'
Application.start()
